import { render, staticRenderFns } from "./Plantool.vue?vue&type=template&id=092d2140&"
import script from "./Plantool.vue?vue&type=script&lang=js&"
export * from "./Plantool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports